/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */
import _regeneratorRuntime from "E:\\ysh\\wx-master\\node_modules\\_@babel_runtime@7.16.5@@babel\\runtime\\regenerator\\index.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
/*
 * @Description: 工具集合
 * @Date: 2019-09-17 10:55:01
 */


import axios from 'axios';
import dateFormat from './dateFormat';
export var transAllTime = function transAllTime(input) {
  if (typeof input == 'number') {
    return dateFormat(input, 'YYYY年MM月DD日 HH时mm分');
  } else {
    return '';
  }
};
export var transMonth = function transMonth(input) {
  if (typeof input == 'number') {
    return dateFormat(input, 'YYYY年MM月');
  } else {
    return '';
  }
};
/**
 * @description: 简易拷贝
 * @param {object} target
 * @return: object
 */

export var easyCopy = function easyCopy(target) {
  return JSON.parse(JSON.stringify(target));
};
/**
 * @description: 深拷贝
 * @param {object} target
 * @return: object
 */

export var deepClone = function deepClone(target) {
  var result;

  if (_typeof(target) === 'object') {
    if (Array.isArray(target)) {
      result = [];

      for (var i in target) {
        result.push(deepClone(target[i]));
      }
    } else if (target === null) {
      result = null;
    } else if (target.constructor === RegExp) {
      result = target;
    } else {
      result = {};

      for (var _i in target) {
        result[_i] = deepClone(target[_i]);
      }
    }
  } else {
    result = target;
  }

  return result;
};
/**
 * @description: 获取类型
 * @param {type} field 传入需要判断的字段
 * @return: {string}  [object Number] [object String] [object Number]
 *                    [object Function] [object Array] [object Undefined]
 *                    [object Boolean] [object Null]
 */

export var getTypeToString = function getTypeToString(field) {
  return Object.prototype.toString.call(field);
};
/**
 * @description: 获取百分比
 * @param {number,number,object}
 * @return: string|number
 */

export var percentage = function percentage() {
  var dividend = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var divisor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var args = _objectSpread({
    digit: 2,
    multiple: 100,
    symbol: '%'
  }, options);

  var res = (dividend / divisor * args.multiple).toFixed(args.digit);
  var p = isNaN(res) ? 0 : res;
  return p;
}; // base64转换为blob流

export var dataURLToBlob = function dataURLToBlob(dataurl) {
  var arr = dataurl.split(',');
  var mime = arr[0].match(/:(.*?);/)[1];
  var bstr = atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new Blob([u8arr], {
    type: mime
  });
}; // blob流转换为base64

export var blobToDataURI = function blobToDataURI(blob) {
  return new Promise(function (resolve) {
    var reader = new FileReader();
    reader.readAsDataURL(blob);

    reader.onload = function (e) {
      resolve(e.target.result);
    };
  });
};
export var getNetFile = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    var responseType,
        options,
        _yield$axios$get,
        data,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            responseType = _args.length > 1 && _args[1] !== undefined ? _args[1] : 'blob';
            options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {
              data: {
                noInterceptor: true
              }
            };
            _context.next = 4;
            return axios.get(url, _objectSpread({
              responseType: responseType
            }, options));

          case 4:
            _yield$axios$get = _context.sent;
            data = _yield$axios$get.data;
            return _context.abrupt("return", data);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getNetFile(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var image2Base64 = function image2Base64(img) {
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d');
  canvas.width = img.width;
  canvas.height = img.height;
  ctx.drawImage(img, 0, 0, img.width, img.height);
  var dataURL = canvas.toDataURL('image/png');
  return dataURL;
};
export var getImgBase64 = function getImgBase64(src) {
  return new Promise(function (resolve) {
    var base64 = '';
    var img = new Image();
    img.setAttribute('crossOrigin', 'anonymous');
    img.src = src;

    img.onload = function () {
      base64 = image2Base64(img);
      resolve(base64);
    };
  });
};
export var uniqueByFieldName = function uniqueByFieldName(array, id) {
  if (!Array.isArray(array)) {
    return new TypeError('array:' + array);
  }

  var result = [];
  var keys = {};

  for (var i = 0; i < array.length; i++) {
    var row = array[i];

    if (!keys[row[id]]) {
      keys[row[id]] = result.push(row);
    }
  }

  return result;
};
/**
 * @description: *代替字符串部分内容
 * @param {content} 内容
 * @param {start} 开始部分
 * @param {end} 结束部分
 * @return: String
 */

export var hideSomeString = function hideSomeString(content) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
  var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 7;
  var stars = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 4; // return content.replace(/(\d{3})(\d{4})(\d{4})/, '$1****$3');

  content = String(content);
  return content.substr(0, start) + '*'.repeat(stars) + content.substr(end);
};
/**
 * @name 根据枚举生成 select 选项
 * @param enums
 * @param fieldLable
 * @param fieldKey
 * @return {[{label: string, value: string}]}
 */

export var makeSelectOptionsByEnum = function makeSelectOptionsByEnum(enums) {
  var _ref2;

  var fieldLable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'label';
  var fieldKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'value';
  var arr = [];

  for (var key in enums) {
    var _arr$push;

    var label = enums[key];
    arr.push((_arr$push = {}, _defineProperty(_arr$push, fieldLable, label + ''), _defineProperty(_arr$push, fieldKey, key + ''), _arr$push));
  }

  arr.sort(function (a, b) {
    return Math.abs(a.value) - Math.abs(b.value);
  }); // return res.sort((a, b) => a.order - b.order);

  return [(_ref2 = {}, _defineProperty(_ref2, fieldLable, '全部'), _defineProperty(_ref2, fieldKey, ''), _ref2)].concat(arr);
}; // 处理日期字段 有可能是字符串 ，也有可能是时间戳的情况

export var fieldRender = function fieldRender(type, val) {
  // 时间戳 正则
  var tempReg = /\d{13}/g;
  var timeStr = /^\d+-\d+-\d+/g;

  if (type === 'datetime') {
    if (tempReg.test(val)) {
      var date = new Date(val);
      var yyyy = date.getFullYear(),
          MM = (date.getMonth() + 101 + '').slice(1),
          dd = (date.getDate() + 100 + '').slice(1),
          HH = (date.getHours() + 100 + '').slice(1),
          mm = (date.getMinutes() + 100 + '').slice(1),
          ss = (date.getSeconds() + 100 + '').slice(1);
      return "".concat(yyyy, "-").concat(MM, "-").concat(dd, " ").concat(HH, ":").concat(mm, ":").concat(ss);
    }

    if (timeStr.test(val)) {
      return val;
    }
  }
};
/**
 * 下载文件
 * @param {*} fileName
 * @param {*} content
 */

export var downloadFile = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(fileName, url) {
    var options,
        res,
        blob,
        link,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
            _context2.prev = 1;
            _context2.next = 4;
            return axios(_objectSpread({
              method: 'get',
              url: url,
              responseType: 'arraybuffer',
              headers: {// [Config.token]: getToken()
              }
            }, options));

          case 4:
            res = _context2.sent;
            blob = new Blob([res.data]);

            if (window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = fileName;
              link.click();
              window.URL.revokeObjectURL(link.href);
            }

            return _context2.abrupt("return", Promise.resolve());

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](1);
            return _context2.abrupt("return", Promise.reject(_context2.t0));

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 10]]);
  }));

  return function downloadFile(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();
export var makeTableRenderOptionsByMap = function makeTableRenderOptionsByMap(map, all) {
  if (!Object.prototype.toString.call(map).toLowerCase().includes('map')) {
    throw new TypeError('map 参数类型错误');
  }

  var res = [];
  all && res.push({
    name: '全部',
    key: ''
  });

  try {
    map.forEach(function (v, k) {
      res.push({
        name: v,
        key: k
      });
    });
  } catch (err) {
    return res;
  }

  return res;
};